import Choices from "choices.js";
// import styles from "choices.js/public/assets/styles/choices.css";
import "choices.js/public/assets/styles/choices.css";

import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { initMasonry } from "./masonry/masonry";

// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function () {
    // Initialize Choices.js
    initChoices();

    // Initialize sidebar toggle functionality
    initSidebarToggle();

    // Initialize Swiper
    initPodcasts();

    // Initialize podcasts links
    initSwiper();

    // update grid columns on load
    updateGridColumns();

    // init masonry if needed
    // initMasonry();
});

window.addEventListener("resize", updateGridColumns);

function updateGridColumns() {
    // check if we are on the dashboard page with publications grid
    const isDashboard = document.querySelector(".dashboard-page");
    if (!isDashboard) return;

    const grid = document.querySelector(".publications-grid");
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll(".publication-card"));
    if (cards.length === 0) return;

    const card = cards[0];
    const gridWidth = grid.offsetWidth;
    const cardWidth = card.offsetWidth;

    const columns = Math.floor(gridWidth / cardWidth);

    // Als er minder kaarten zijn dan het aantal kolommen → toon alles
    if (cards.length <= columns) {
        cards.forEach((card) => (card.style.display = ""));
        return;
    }

    const fullRows = Math.floor(cards.length / columns);
    const visibleCount = fullRows * columns;

    cards.forEach((card, index) => {
        card.style.display = index < visibleCount ? "" : "none";
    });
}

function initChoices() {
    // Initialize Choices.js for select elements
    const element = document.getElementById("categorySelect");
    if (!element) {
        return;
    }
    const choices = new Choices(element, {
        removeItemButton: true,
        placeholderValue: "Kies categorieën",
        noResultsText: "Geen resultaten gevonden",
        noChoicesText: "Geen opties beschikbaar",
        itemSelectText: "",
    });
}

function initSidebarToggle() {
    // Sidebar toggle functionality
    const sidebarToggle = document.getElementById("sidebarToggle");
    const sidebarCollapseToggle = document.getElementById(
        "sidebarCollapseToggle"
    );
    const sidebar = document.querySelector(".sidebar");
    const mainContent = document.querySelector(".main-content");

    if (sidebarToggle) {
        sidebarToggle.addEventListener("click", function () {
            sidebar.classList.toggle("show");
            document.body.classList.toggle("sidebar-open");

            // Add backdrop when sidebar is shown on mobile
            if (sidebar.classList.contains("show")) {
                const backdrop = document.createElement("div");
                backdrop.classList.add("sidebar-backdrop", "show");
                backdrop.addEventListener("click", function () {
                    sidebar.classList.remove("show");
                    document.body.classList.remove("sidebar-open");
                    this.remove();
                });
                document.body.appendChild(backdrop);
            }
        });
    }

    if (sidebarCollapseToggle) {
        sidebarCollapseToggle.addEventListener("click", function () {
            sidebar.classList.toggle("sidebar-collapsed");
            mainContent.classList.toggle("expanded");

            // Change icon direction
            const icon = this.querySelector("i");
            if (icon) {
                if (sidebar.classList.contains("sidebar-collapsed")) {
                    icon.classList.remove("fa-angle-double-left");
                    icon.classList.add("fa-angle-double-right");
                } else {
                    icon.classList.remove("fa-angle-double-right");
                    icon.classList.add("fa-angle-double-left");
                }
            }

            const state = sidebar.classList.contains("sidebar-collapsed")
                ? "collapsed"
                : "open";

            // fetch to API to save sidebar state
            fetch("/api/session/sidebar", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    state: state,
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {
                    console.log("Sidebar state saved:", data);
                })
                .catch((error) => {
                    console.error("Error saving sidebar state:", error);
                });
        });
    }
}

function initSwiper() {
    // Zoek alle Swipers op de pagina
    document.querySelectorAll(".swiper").forEach((swiperElement, index) => {
        const swiperInstance = new Swiper(swiperElement, {
            direction: "horizontal",
            slidesPerView: "auto",
            allowTouchMove: true,
            autoHeight: true,
            spaceBetween: 30,
            centeredSlides: false,
            width: null,
            resizeObserver: true,
            watchOverflow: true,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 30, // Voeg extra ruimte toe aan het einde
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    slidesOffsetAfter: 20,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    slidesOffsetAfter: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    slidesOffsetAfter: 30,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                    slidesOffsetAfter: 30,
                },
            },
            mousewheel: {
                forceToAxis: false,
                sensitivity: 1,
                releaseOnEdges: true,
            },
            pagination: {
                el: swiperElement.querySelector(".swiper-pagination"),
            },
            navigation: {
                nextEl: swiperElement.parentElement.querySelector(
                    ".swiper-button-next"
                ),
                prevEl: swiperElement.parentElement.querySelector(
                    ".swiper-button-prev"
                ),
            },
        });

        // Herbereken scrollbar positie bij resize
        window.addEventListener("resize", () => {
            swiperInstance.update();
            // setTimeout(() => setScrollBarPosition(swiperElement), 100); // Zorgt ervoor dat de update correct is
        });
    });
}

function initPodcasts() {
    document.querySelectorAll(".card-podcast").forEach(function (link) {
        link.addEventListener("click", function (e) {
            // check if the link is premium by data attribute
            const isPremium = this.dataset.ispremium === "1";
            const hasAccess = this.dataset.hasaccess === "1";
            if (isPremium && !hasAccess) {
                return; // Laat de browser zijn ding doen
            }

            // Voorkom alleen bij gewone klikken (zonder Ctrl/Cmd/Middle)
            if (
                e.ctrlKey || // Ctrl ingedrukt
                e.metaKey || // Cmd ingedrukt (Mac)
                e.button !== 0 // Niet linkermuisknop
            ) {
                return; // Laat de browser zijn ding doen
            }

            e.preventDefault();
            window.open(
                this.href + "?window",
                "podcastPlayer",
                "width=600,height=600,scrollbars=yes,resizable=yes"
            );
            window.location.href = this.href + "?autoplay=0";
        });
    });
}

// Bepaal hoeveel slides er zichtbaar zijn op basis van schermbreedte
function getSlidesPerView() {
    const width = window.innerWidth;
    if (width >= 1200) return 4;
    if (width >= 768) return 3;
    if (width >= 576) return 2;
    return 1;
}
